import { Column, SectionedCard, Text, TextExternalLink } from "@bridgesplit/ui";
import { VaultDocLinkItem } from "@bridgesplit/abf-react";

export function DocumentationCard({ docs }: { docs?: VaultDocLinkItem[] }) {
    if (docs && docs.length === 0) return null;
    return (
        <SectionedCard title="Documentation">
            {!docs ? (
                <Text variant="body2" loading loadingWidth="160px">
                    &nbsp;
                </Text>
            ) : (
                <Column spacing={1}>
                    {docs.map((doc) => (
                        <TextExternalLink key={doc.url} href={doc.url}>
                            <Text variant="body1">{doc.label}</Text>
                        </TextExternalLink>
                    ))}
                </Column>
            )}
        </SectionedCard>
    );
}
